/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WalletCoupon } from '../../models/wallet-coupon';
import { WalletCouponHalResponse } from '../../models/wallet-coupon-hal-response';

export interface AddCoupon$Params {
  'Active-Tenant-Identifier': string;
      body: WalletCoupon
}

export function addCoupon(http: HttpClient, rootUrl: string, params: AddCoupon$Params, context?: HttpContext): Observable<StrictHttpResponse<WalletCouponHalResponse>> {
  const rb = new RequestBuilder(rootUrl, addCoupon.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WalletCouponHalResponse>;
    })
  );
}

addCoupon.PATH = '/wallet/coupons';
